import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Banner.css";

const fallbackBanner = {
  bannerHeading: "AI Automation",
  bannerTextTwo: "That Helps",
  bannerText: "Service Businesses Grow Faster",
  bannerDetails:
    "Capture leads, answer questions, and automate follow-up with practical AI systems built for real businesses.",
  buttonText: "Book a Free Demo",
  buttonTextTwo: "Trusted by growing local businesses",
  imageOne: "assets/images/banner/banner-img-1.png",
};

const Banner = () => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/banner`)
      .then((res) => res.json())
      .then((info) => setBanners(info))
      .catch(() => setBanners([]));
  }, []);

  const banner = banners[0] || fallbackBanner;

  return (
    <section className="banner-style-six modern-hero-section">
      <div className="pattern-layer">
        <div className="pattern-1" style={{ backgroundImage: "url(assets/images/shape/shape-49.png)" }} />
        <div className="pattern-2" style={{ backgroundImage: "url(assets/images/shape/shape-50.png)" }} />
      </div>

      <div className="auto-container">
        <div className="modern-hero-shell">
          <div className="row align-items-center g-4">
            <div className="col-lg-6 col-md-12 col-sm-12 content-column">
              <div className="modern-hero-copy">
                <span className="modern-eyebrow">AI automation for ambitious small businesses</span>
                <h1>
                  {banner.bannerHeading} <span>{banner.bannerTextTwo}</span> {banner.bannerText}
                </h1>
                <p>{banner.bannerDetails}</p>

                <div className="modern-hero-actions">
                  <Link to="/contact-us" className="theme-btn btn-one">
                    {banner.buttonText || "Book a Free Demo"}
                  </Link>
                  <Link to="/pricing" className="theme-btn btn-two">
                    See Pricing
                  </Link>
                </div>

                <div className="modern-hero-points">
                  <span>24/7 lead capture</span>
                  <span>Monthly plans</span>
                  <span>Fast setup</span>
                </div>

                <div className="customer-review modern-customer-review">
                  <ul className="image-box clearfix modern-review-avatars">
                    <li><img src="https://i.ibb.co.com/zWdppvgy/customer-1.jpg" alt="Client" /></li>
                    <li><img src="https://i.ibb.co.com/G38XnL1M/customer-4.jpg" alt="Client" /></li>
                    <li><img src="https://i.ibb.co.com/d9jbHZT/customer-3.jpg" alt="Client" /></li>
                    <li><img src="https://i.ibb.co.com/Y7dmYBGW/customer-5.jpg" alt="Client" /></li>
                  </ul>
                  <div className="modern-review-copy">
                    <ul className="rating-box modern-review-stars">
                      <li><i className="icon-19" /></li>
                      <li><i className="icon-19" /></li>
                      <li><i className="icon-19" /></li>
                      <li><i className="icon-19" /></li>
                      <li><i className="icon-19" /></li>
                    </ul>
                    <h6>{banner.buttonTextTwo || "Trusted by growing local businesses"}</h6>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 col-sm-12 image-column">
              <div className="modern-hero-visual">
                <div className="modern-hero-card">
                  <div className="modern-hero-stat stat-top">
                    <strong>24/7</strong>
                    <span>Instant replies</span>
                  </div>
                  <figure className="image">
                    <img src={banner.imageOne || fallbackBanner.imageOne} alt="AuraWeb AI automation" />
                  </figure>
                  <div className="modern-hero-stat stat-bottom">
                    <strong>More Leads</strong>
                    <span>Automate follow-up and bookings</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
